import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_up",
  "use": "icon-arrow_up-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow_up\"><path d=\"M743.936 641.536a38.4 38.4 0 0 1-54.272 0L512 463.872l-177.664 177.664a38.4 38.4 0 0 1-54.272-54.272l204.8-204.8a38.4 38.4 0 0 1 54.272 0l204.8 204.8a38.4 38.4 0 0 1 0 54.272z\" p-id=\"4093\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol